import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import CustomClipLoader from '~components/atoms/CustomClipLoader';
import * as Styles from './CustomerTransferDetails.module.scss';
import Text from '~components/atoms/Text';
import DetailsFormCustomerTransferModal from '../DetailsFormCustomerTransferModal';

const CustomerTransferDetailsModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.customerTransfer.modals.isCustomerTransferDetailsModalOpen);
    const isLoading = useAppSelector(state => state.customerTransfer.loadings.getCustomerTransferDetails);
    const error = useAppSelector(state => state.customerTransfer.errors.getCustomerTransferDetails);

    const handleModalOnClose = () => dispatch(combinedActions.customerTransferSetIsCustomerTransferDetailsModalOpen(false));

    return (
        <Modal
            title='Customer Transfer Transaction Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {isLoading ? (
                <CustomClipLoader
                    blackBorder
                    className={Styles.loader}
                />
            ) : error ? (
                <Text
                    isError
                    label={error}
                />
            ) : (
                <DetailsFormCustomerTransferModal />
            )}
        </Modal>
    );
};

export default CustomerTransferDetailsModal;
